module.exports = __webpack_public_path__ + "static/img/quanguo_si.49c9a83f.png";